import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { uniqueId } from 'lodash';
import React from 'react';
import DialogTitleWithClose from 'src/components/elements/DialogTitleWithClose';

interface AccountDialogProps {
    open: boolean;
    onClose: () => void;
    header?: React.ReactNode;
    subHeader?: React.ReactNode;
    content?: React.ReactNode;
    actions?: React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const AccountDialog: React.FC<AccountDialogProps> = ({
    open,
    onClose,
    header,
    subHeader,
    content,
    maxWidth,
    actions,
}) => {
    const id = uniqueId();

    return (
        <Dialog disableEscapeKeyDown onClose={onClose} aria-labelledby={id} open={open} maxWidth={maxWidth}>
            <DialogTitleWithClose onClose={onClose} id={id}>
                <div>
                    {header && (
                        <Typography component="div" variant="h4" color="primary">
                            {header}
                            &nbsp;
                        </Typography>
                    )}
                    {subHeader && (
                        <Typography component="div" variant="h4Sub" color="secondary">
                            {subHeader}
                        </Typography>
                    )}
                </div>
            </DialogTitleWithClose>
            <DialogContent>{content}</DialogContent>
            {actions && <DialogActions>{actions}</DialogActions>}
        </Dialog>
    );
};

export default AccountDialog;
